type RemoveType = 'deactivate' | 'delete';

export function getSuccessMessage(type: RemoveType): {
  title: string;
  content: string;
} {
  return {
    title: `anúncio ${type === 'deactivate' ? 'desativado' : 'excluído'}`,
    content: `Seu anúncio foi ${type === 'deactivate' ? 'desativado' : 'excluído'} com sucesso`
  };
}

export function getErrorMessage(type: RemoveType): {
  title: string;
  content: string;
} {
  return {
    title: `seu anúncio não foi ${type === 'deactivate' ? 'desativado' : 'excluído'}`,
    content: `Não conseguimos ${
      type === 'deactivate' ? 'desativar' : 'excluir'
    } seu anúncio neste momento`
  };
}
